import { useEffect, useState } from "react";
import { addressesFromOrders } from "./profileData";

/* Enough recent orders to build a useful address book without a burst of
 * requests on a long history. */
const LOOKUP_LIMIT = 10;

/*
 * There is no address model, and the history endpoint projects only items,
 * totals and status — so the billing and delivery addresses come from the
 * full order documents, read one at a time through the existing
 * GET /order/getoneorder/:orderId route.
 */
export const useOrderAddresses = (orders) => {
  const [addresses, setAddresses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const ids = orders
    .slice(0, LOOKUP_LIMIT)
    .map((order) => order._id)
    .join(",");

  useEffect(() => {
    if (!ids) {
      setAddresses([]);
      return undefined;
    }

    let cancelled = false;
    const baseURL = process.env.REACT_APP_BACKEND_URL;
    setIsLoading(true);

    Promise.all(
      ids.split(",").map((id) =>
        fetch(`${baseURL}/order/getoneorder/${id}`, { credentials: "include" })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    )
      .then((results) => {
        if (cancelled) return;
        setAddresses(addressesFromOrders(results.filter(Boolean)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [ids]);

  return { addresses, isLoading };
};
